import { createContext, useContext } from 'react';
import { DebuggableError } from 'utils/errors/debuggableError';

type RequestResetPasswordFormContextValue = {
  onBack?: () => void;
  formClassname?: string;
};

export const RequestResetPasswordFormContext = createContext<RequestResetPasswordFormContextValue>(
  {} as RequestResetPasswordFormContextValue,
);

export const useRequestResetPasswordFormContext = () => {
  const ctx = useContext(RequestResetPasswordFormContext);
  if (!ctx) {
    throw new DebuggableError(
      'useRequestResetPasswordFormContext must be used within a RequestResetPasswordFormContextProvider',
    );
  }
  return ctx;
};
